import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MasterHelper } from 'src/app/core/utilities';
import { SelfAssessmentT3KeyInformationSummaryDto, SelfassessmentKeyInformation } from 'src/app/core/models/self-assessmentT3/selfassessmentKeyInformation';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-key-information',
  templateUrl: './key-information.component.html',
  styleUrls: ['./key-information.component.scss'],
})
export class KeyInformationComponent {
  keyInformation: SelfassessmentKeyInformation;
  effectiveDate: string;
  summaryDetailsData: any;
  myInnerHeight: number;
  isLoadingSummaryData: boolean = true;
  selectedApprovers: string[] = [];
  approverFilterList!: SelfAssessmentT3KeyInformationSummaryDto;
  @Input() selfAssessmentId: number;
  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private selfAssessment3Service: SelfAssessmentTemplate3Service
  ) {
    this.keyInformation = new SelfassessmentKeyInformation();
    this.effectiveDate = '';
    this.selfAssessmentId = 0;
    this.myInnerHeight = window.innerHeight - 190;
  }
  ngOnInit(): void {
    if (this.selfAssessmentId == 0) {
      this.selfAssessmentId = Number(this.route.snapshot.params['id']);
    }
    this.getSelfassessmentKeyInformation(this.selfAssessmentId);
    this.getSelfAssessmentKeyInformationSummarryDetails(this.selfAssessmentId);
  }
  getSelfassessmentKeyInformation(id: number) {
    this.selfAssessment3Service
      .getTKeyInformationAssessment(id)
      .subscribe((data: any) => {
        this.keyInformation = data;
      });
  }
  getSelfAssessmentKeyInformationSummarryDetails(id: number) {
    this.selfAssessment3Service
      .getKeyInformationSummury(id)
      .subscribe((data: SelfAssessmentT3KeyInformationSummaryDto) => {
        this.summaryDetailsData = data;
        if (this.summaryDetailsData) {
          this.isLoadingSummaryData = false;
        }
      });
  }
}
